// extracted by mini-css-extract-plugin
export var content = "_cd-3";
export var list = "_cd-4";
export var settingsContent = "_cd-7";
export var settingsPanel = "_cd-8";
export var state = "_cd-6";
export var triggerBadge = "_cd-2";
export var triggerButton = "_cd-1";
export var triggerShell = "_cd-0";
export var unreadDot = "_cd-5";